export default __webpack_public_path__ + "static/media/tissue-roll-view.ccd11cf4.svg";